import React from 'react';

const Checkbox = ({ name, label, value, placeholder, onChange }) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <label htmlFor={name} className="checkbox-label">
        <input
          type="checkbox"
          id={name}
          name={name}
          value={value}
          checked={value}
          onChange={onChange}
        />
        {placeholder}
      </label>
    </div>
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/forms/checkbox.jsx